module.exports = __webpack_public_path__ + "img/1.f34cf7ad.png";